import { ProfileBlock } from "@k8slens/lds";
import { useCallback } from "react";
import styles from "./EmptyAvatar.module.css";

export const emptySeatTooltip =
  "Lens ID does not longer exist or is not part of your Organization anymore. Offline seat will be released at the end of the billing cycle.";

export function EmptyBlock({ title }: { title?: string }) {
  return <div title={title} className={styles.emptyBlock} style={{ width: "4rem", height: "1rem" }}></div>;
}

export function EmptyAvatar({ title }: { title?: string }) {
  const formatTitle = useCallback(() => <EmptyBlock title={title} />, [title]);

  return (
    <ProfileBlock
      color="red"
      className={styles.emptyAvatar}
      item={{ title: "", subtitle: "", avatar: null, avatarTitle: "" }}
      formatTitle={formatTitle}
      title={title}
    />
  );
}
